const PREVIEW_LENGTH = 3;

/**
 * Get the a number of elements, before and after the current selected index
 * @param index       The index of the currently visible item.
 * @param elements    The elements that the user is viewing.
 */
export const getSurroundingElements = <T = any[]>(index: number, elements: T[]): [T[], T[]] => {
    const startIndex = index - PREVIEW_LENGTH < 0 ? 0 : index - PREVIEW_LENGTH;
    const elementsBefore = elements.slice(startIndex, index);
    const elementsAfter = elements.slice(index + 1, index + PREVIEW_LENGTH + 1);

    return [elementsBefore, elementsAfter];
};
